import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error(
    "\n⚠️  Missing Supabase environment variables!\n" +
    "Please add these to your .env.local file:\n" +
    "  NEXT_PUBLIC_SUPABASE_URL=your_supabase_url\n" +
    "  NEXT_PUBLIC_SUPABASE_ANON_KEY=your_supabase_anon_key\n"
  );
  throw new Error("Missing Supabase environment variables");
}

export const supabase = createClient(supabaseUrl, supabaseKey);